/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addProductTag } from '../fn/product-api/add-product-tag';
import { AddProductTag$Params } from '../fn/product-api/add-product-tag';
import { ApiResponseListProduct } from '../models/api-response-list-product';
import { ApiResponsePagedResultProduct } from '../models/api-response-paged-result-product';
import { ApiResponsePagedResultTagDto } from '../models/api-response-paged-result-tag-dto';
import { ApiResponseProduct } from '../models/api-response-product';
import { ApiResponseProductUploadResult } from '../models/api-response-product-upload-result';
import { ApiResponseSyncConfig } from '../models/api-response-sync-config';
import { ApiResponseVoid } from '../models/api-response-void';
import { archiveProduct } from '../fn/product-api/archive-product';
import { ArchiveProduct$Params } from '../fn/product-api/archive-product';
import { createProduct } from '../fn/product-api/create-product';
import { CreateProduct$Params } from '../fn/product-api/create-product';
import { deleteProduct } from '../fn/product-api/delete-product';
import { DeleteProduct$Params } from '../fn/product-api/delete-product';
import { getProductById } from '../fn/product-api/get-product-by-id';
import { GetProductById$Params } from '../fn/product-api/get-product-by-id';
import { getProductByRef } from '../fn/product-api/get-product-by-ref';
import { GetProductByRef$Params } from '../fn/product-api/get-product-by-ref';
import { getProductList } from '../fn/product-api/get-product-list';
import { GetProductList$Params } from '../fn/product-api/get-product-list';
import { listProducts } from '../fn/product-api/list-products';
import { ListProducts$Params } from '../fn/product-api/list-products';
import { removeProductTag } from '../fn/product-api/remove-product-tag';
import { RemoveProductTag$Params } from '../fn/product-api/remove-product-tag';
import { reorderProductTags } from '../fn/product-api/reorder-product-tags';
import { ReorderProductTags$Params } from '../fn/product-api/reorder-product-tags';
import { searchProduct } from '../fn/product-api/search-product';
import { SearchProduct$Params } from '../fn/product-api/search-product';
import { searchTags } from '../fn/product-api/search-tags';
import { SearchTags$Params } from '../fn/product-api/search-tags';
import { syncProduct } from '../fn/product-api/sync-product';
import { SyncProduct$Params } from '../fn/product-api/sync-product';
import { syncProductsFromWordpress } from '../fn/product-api/sync-products-from-wordpress';
import { SyncProductsFromWordpress$Params } from '../fn/product-api/sync-products-from-wordpress';
import { toggleInStock } from '../fn/product-api/toggle-in-stock';
import { ToggleInStock$Params } from '../fn/product-api/toggle-in-stock';
import { updateProduct } from '../fn/product-api/update-product';
import { UpdateProduct$Params } from '../fn/product-api/update-product';
import { uploadProducts } from '../fn/product-api/upload-products';
import { UploadProducts$Params } from '../fn/product-api/upload-products';

@Injectable({ providedIn: 'root' })
export class ProductApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateProduct()` */
  static readonly UpdateProductPath = '/v1/api/products/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProduct$Response(params: UpdateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return updateProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProduct(params: UpdateProduct$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.updateProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `deleteProduct()` */
  static readonly DeleteProductPath = '/v1/api/products/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProduct$Response(params: DeleteProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return deleteProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProduct(params: DeleteProduct$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.deleteProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `reorderProductTags()` */
  static readonly ReorderProductTagsPath = '/v1/api/products/{ref}/tags/reorder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reorderProductTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reorderProductTags$Response(params: ReorderProductTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return reorderProductTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reorderProductTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reorderProductTags(params: ReorderProductTags$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.reorderProductTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `addProductTag()` */
  static readonly AddProductTagPath = '/v1/api/products/{ref}/tag';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProductTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProductTag$Response(params: AddProductTag$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return addProductTag(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addProductTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProductTag(params: AddProductTag$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.addProductTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `searchTags()` */
  static readonly SearchTagsPath = '/v1/api/products/tags/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTags$Response(params: SearchTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTagDto>> {
    return searchTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTags(params: SearchTags$Params, context?: HttpContext): Observable<ApiResponsePagedResultTagDto> {
    return this.searchTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultTagDto>): ApiResponsePagedResultTagDto => r.body)
    );
  }

  /** Path part for operation `createProduct()` */
  static readonly CreateProductPath = '/v1/api/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProduct$Response(params: CreateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return createProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProduct(params: CreateProduct$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.createProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `uploadProducts()` */
  static readonly UploadProductsPath = '/v1/api/products/upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadProducts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadProducts$Response(params: UploadProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProductUploadResult>> {
    return uploadProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadProducts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadProducts(params: UploadProducts$Params, context?: HttpContext): Observable<ApiResponseProductUploadResult> {
    return this.uploadProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProductUploadResult>): ApiResponseProductUploadResult => r.body)
    );
  }

  /** Path part for operation `searchProduct()` */
  static readonly SearchProductPath = '/v1/api/products/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchProduct$Response(params: SearchProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultProduct>> {
    return searchProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchProduct(params: SearchProduct$Params, context?: HttpContext): Observable<ApiResponsePagedResultProduct> {
    return this.searchProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultProduct>): ApiResponsePagedResultProduct => r.body)
    );
  }

  /** Path part for operation `listProducts()` */
  static readonly ListProductsPath = '/v1/api/products/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProducts$Response(params: ListProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListProduct>> {
    return listProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProducts(params: ListProducts$Params, context?: HttpContext): Observable<ApiResponseListProduct> {
    return this.listProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListProduct>): ApiResponseListProduct => r.body)
    );
  }

  /** Path part for operation `syncProductsFromWordpress()` */
  static readonly SyncProductsFromWordpressPath = '/v1/api/products/external-sync/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncProductsFromWordpress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  syncProductsFromWordpress$Response(params: SyncProductsFromWordpress$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListProduct>> {
    return syncProductsFromWordpress(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncProductsFromWordpress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  syncProductsFromWordpress(params: SyncProductsFromWordpress$Params, context?: HttpContext): Observable<ApiResponseListProduct> {
    return this.syncProductsFromWordpress$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListProduct>): ApiResponseListProduct => r.body)
    );
  }

  /** Path part for operation `toggleInStock()` */
  static readonly ToggleInStockPath = '/v1/api/products/in-stock/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `toggleInStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  toggleInStock$Response(params: ToggleInStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return toggleInStock(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `toggleInStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  toggleInStock(params: ToggleInStock$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.toggleInStock$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `archiveProduct()` */
  static readonly ArchiveProductPath = '/v1/api/products/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveProduct$Response(params: ArchiveProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return archiveProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveProduct(params: ArchiveProduct$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.archiveProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `getProductById()` */
  static readonly GetProductByIdPath = '/v1/api/products/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductById$Response(params: GetProductById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return getProductById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductById(params: GetProductById$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.getProductById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `getProductList()` */
  static readonly GetProductListPath = '/v1/api/products/unarchived_prodcut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductList$Response(params: GetProductList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListProduct>> {
    return getProductList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductList(params: GetProductList$Params, context?: HttpContext): Observable<ApiResponseListProduct> {
    return this.getProductList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListProduct>): ApiResponseListProduct => r.body)
    );
  }

  /** Path part for operation `syncProduct()` */
  static readonly SyncProductPath = '/v1/api/products/sync-products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncProduct$Response(params: SyncProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSyncConfig>> {
    return syncProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncProduct(params: SyncProduct$Params, context?: HttpContext): Observable<ApiResponseSyncConfig> {
    return this.syncProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSyncConfig>): ApiResponseSyncConfig => r.body)
    );
  }

  /** Path part for operation `getProductByRef()` */
  static readonly GetProductByRefPath = '/v1/api/products/ref/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductByRef$Response(params: GetProductByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return getProductByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductByRef(params: GetProductByRef$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.getProductByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

  /** Path part for operation `removeProductTag()` */
  static readonly RemoveProductTagPath = '/v1/api/products/{ref}/tag/{tagref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeProductTag$Response(params: RemoveProductTag$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
    return removeProductTag(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeProductTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeProductTag(params: RemoveProductTag$Params, context?: HttpContext): Observable<ApiResponseProduct> {
    return this.removeProductTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProduct>): ApiResponseProduct => r.body)
    );
  }

}
